import MuiTooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export const Tooltip = styled(MuiTooltip)(() => ({}));
